"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const clsx_1 = __importDefault(require("clsx"));
// eslint-disable-next-line css-modules/no-unused-class
const ConsumerNavIcon_module_css_1 = __importDefault(require("../../ConsumerNavIcon.module.css"));
/**
 * Icon for chat
 */
function ChatIcon(props) {
    const baseClass = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.v2Icon, { [ConsumerNavIcon_module_css_1.default.active]: props.active });
    const pathClasses = (0, clsx_1.default)(ConsumerNavIcon_module_css_1.default.ba);
    const titleId = "chat-title-id";
    return ((0, jsx_runtime_1.jsxs)("svg", { width: "21", height: "23", viewBox: "0 0 22 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: baseClass, "aria-describedby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: titleId, children: "Try the new Snapchat on web to chat" }), (0, jsx_runtime_1.jsx)("path", { d: "M21.6667 20.4743V22.9763C21.6667 23.5417 21.1891 24 20.6 24C20.3811 24 20.1676 23.9354 19.9883 23.8149L15.0161 20.4743H5.66667C2.72115 20.4743 0.333336 18.1827 0.333336 15.3557V5.11858C0.333336 2.29167 2.72115 0 5.66667 0H16.3333C19.2789 0 21.6667 2.29167 21.6667 5.11858V20.4743Z", className: pathClasses })] }));
}
exports.ChatIcon = ChatIcon;
//# sourceMappingURL=ChatIcon.js.map